import { useSearchParams } from "react-router";

import { Skeleton } from "../../components/Skeleton";
import { nl } from "../../i18n/nl";
import { useCompanyDetail } from "../companies/queries";
import { ReportForm } from "./ReportForm";
import styles from "./report.module.css";

/** The form with an optional company id (`?bedrijf=`), whose name is fetched first. */
export function ReportFormFor({ companyId }: { companyId: string | null }) {
  const detail = useCompanyDetail(companyId ?? undefined);
  if (companyId && detail.isPending) {
    return (
      <div role="status" aria-busy="true" aria-label={nl.common.loading}>
        <Skeleton height={50} radius={12} />
      </div>
    );
  }
  const company = detail.data ? { id: detail.data.id, name: detail.data.name } : null;
  return <ReportForm key={company?.id ?? "none"} initialCompany={company} />;
}

/** `/melden`: the full-screen form (mobile, and deep links on desktop). */
export function ReportPage() {
  const [params] = useSearchParams();
  return (
    <div className={styles.page}>
      <h1 className={styles.title}>{nl.report.title}</h1>
      <p className={styles.lead}>{nl.report.lead}</p>
      <ReportFormFor companyId={params.get("bedrijf")} />
    </div>
  );
}
